import { AccommodationBookingsPageContentResponseModel } from '@shared/integrations/umbraco-taf-delivery-api/models';

import Markup from '@shared/components/Markup.tsx';
import AccommodationBookingItem from '@my-pages/features/object-booking/components/AccommodationBookingItem.tsx';
import { useGetApiV2ObjectBookingMemberBookingsSuspense } from '@shared/integrations/taf-api/v2/features/object-booking/object-booking.ts';
import { useEffect, useState } from 'react';
import { IBooking } from '@shared/integrations/taf-api/v2/models';
import { BookingStatus } from '@my-pages/features/object-booking/types/ObjectBooking.ts';
import { isAfter, isSameDay } from 'date-fns';
import AlertBox from '@shared/components/AlertBox.tsx';

interface IAccommodationLandingPage {
    content: AccommodationBookingsPageContentResponseModel;
}

const AccommodationBookingsPage = ({ content }: IAccommodationLandingPage) => {
    const [activeBookings, setActiveBookings] = useState<IBooking[] | undefined>();
    const { data } = useGetApiV2ObjectBookingMemberBookingsSuspense();

    useEffect(() => {
        const active = data.filter((x) => x.status?.status === BookingStatus.Active && x.endDate && (isSameDay(new Date(x.endDate), new Date()) || isAfter(new Date(x.endDate), new Date())));
        setActiveBookings(active);
    }, [data]);

    return (
        <>
            <h1 className='page-title'>{content.properties?.heading ?? content.name}</h1>
            {content.properties?.body && content.properties.body.markup ? (
                <div className='slide-up-fade-in d-flex flex-column gap-4 mb-4'>
                    <div className='row row-gap-4'>
                        <div className='col-xl-8'>
                            <Markup
                                className='mb-2'
                                content={content.properties.body.markup}
                            />
                        </div>
                        {activeBookings && activeBookings.length > 0 ? (
                            activeBookings.map((booking, key) => {
                                return (
                                    <div
                                        className='col-md-6'
                                        key={key}
                                    >
                                        <AccommodationBookingItem booking={booking} />
                                    </div>
                                );
                            })
                        ) : (
                            <div className='col-xl-6'>
                                <AlertBox theme='info'>Du har inga aktiva bokningar</AlertBox>
                            </div>
                        )}
                    </div>
                </div>
            ) : null}
        </>
    );
};

export default AccommodationBookingsPage;
